import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { Review } from "../../sections/references";
import ReviewImage from "./ReviewImage";
import styles from "./companyreview.module.scss";
import CompanyDescription from "./CompanyDescription";

type CompanyReviewProps = {
  review: Review;
};
const CompanyReview: React.FC<CompanyReviewProps> = ({ review }) => {
  return (
    <div>
      <div className={styles.reviewInner}>
        <div className={styles.reviewerData}>
          <ReviewImage
            src={review.image}
            name={review.name}
            position={review.position}
          />
        </div>
        <div className={styles.review}>
          <ReactMarkdown>{review.review}</ReactMarkdown>
        </div>
      </div>
      <CompanyDescription
        logo={review.companyData.logo}
        name={review.companyData.name}
        description={review.companyData.description}
      />
    </div>
  );
};

export default CompanyReview;
